<template>
  <v-container class="containerFillHeight" fluid>
    <v-row no-gutters class="pb-5 mb-5 mx-md-2 px-md-2 mx-sm-1 px-sm-1">
      <div class="divFade">
        <v-row no-gutters class="ma-4">
          <v-col cols="1">
            <v-avatar>
              <img
                :src="`${originFinder}/assets/img/notification/user1.png`"
                alt=""
              />
            </v-avatar>
          </v-col>
          <v-col cols="11" class="pl-4">
            <v-list dense class="pt-1 transparent" dark>
              <v-list-item>
                <v-list-item-content class="pt-1">
                  <v-list-item-title class="chatNameColor">{{
                    name
                  }}</v-list-item-title>
                  <v-list-item-subtitle>I am what I am!!!</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="overflow-y-auto">
            <v-list class="transparent" max-height="52vh">
              <v-list-item
                v-for="message in messages"
                :key="message.messageId"
                :class="`${
                  message.type == 'reply' ? 'directionChanger' : ''
                } my-3`"
              >
                <bdi class="pa-0 ma-0">
                  <v-card
                    max-width="250px"
                    :class="`${
                      message.type == 'reply'
                        ? 'selfMessageTheme'
                        : 'replyMessageTheme'
                    }`"
                    rounded="lg"
                    dark
                  >
                    <v-card-text> {{ message.message }} </v-card-text>
                  </v-card>
                  <p
                    :class="`pa-1 ma-0 float-right timestamp ${
                      message.type == 'reply'
                        ? 'timeSelfMessageTheme'
                        : 'timeReplyMessageTheme'
                    }`"
                  >
                    {{ message.time }}
                  </p>
                </bdi>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col class="">
            <v-text-field
              class="ma-3"
              append-icon="mdi-send mdi-rotate-315"
              label="Message"
              persistent-hint
              outline
              v-model="message"
              rounded
              height="10px"
              dark
              @click:append-icon="test"
              @keydown.enter="test"
            />
          </v-col>
        </v-row>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      name: "Mark V.",
      message: "",
      messages: [
        {
          messageId: 1,
          message: "How about 1 AM ??",
          type: "reply",
          time: "3:23 PM",
        },
        {
          messageId: 2,
          message:
            "That sounds awesome, but I think we will plan this next week cuz I am busy this week...",
          type: "self",
          time: "3:26 PM",
        },
        {
          messageId: 3,
          message:
            "Perfect!!! Looking forward to it, make sure you'll bring your dog with you",
          type: "reply",
          time: "3:40 PM",
        },
        {
          messageId: 4,
          message: "OK!!",
          type: "self",
          time: "3:43 PM",
        },
        {
          messageId: 5,
          message: "OK!!",
          type: "self",
          time: "3:43 PM",
        },
        {
          messageId: 6,
          message: "OK!!",
          type: "self",
          time: "3:43 PM",
        },
        {
          messageId: 7,
          message: "OK!!",
          type: "self",
          time: "3:43 PM",
        },
        {
          messageId: 8,
          message: "OK!!",
          type: "self",
          time: "3:43 PM",
        },
        {
          messageId: 9,
          message: "OK!!",
          type: "self",
          time: "3:43 PM",
        },
        {
          messageId: 10,
          message: "OK!!",
          type: "self",
          time: "3:43 PM",
        },
      ],
    };
  },
  methods: {
    test() {
      this.messages.push({
        messageId: this.messages.length + 1,
        message: this.message,
        type: "reply",
        time: new Date().toLocaleTimeString(),
      });
      this.message = "";
    },
  },
  created() {},
};
</script>

<style scoped>
.divFade {
  height: 75vh;
  background: black;
  border-radius: 15px;
}

.containerFillHeight {
  height: 100%;
}

.chatNameColor {
  color: #c39b4f;
}

.selfMessageTheme {
  background-color: #282828 !important;
}

.replyMessageTheme {
  background-color: #9b7322 !important;
}

.directionChanger {
  direction: rtl;
  unicode-bidi: bidi-override;
}

.timestamp {
  font-size: 0.75rem;
}

.timeReplyMessageTheme {
  color: #9b7322 !important;
}

.timeSelfMessageTheme {
  color: white;
}
</style>
